import { render, staticRenderFns } from "./CancelOrders.vue?vue&type=template&id=2188cb6e&scoped=true&"
import script from "./CancelOrders.vue?vue&type=script&lang=js&"
export * from "./CancelOrders.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrders.vue?vue&type=style&index=0&id=2188cb6e&scoped=true&lang=css&"
import style1 from "./CancelOrders.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188cb6e",
  null
  
)

export default component.exports